import axios from "axios";
import { getToken } from "../Utils/Common";
import token_valid from "./TokenValid";

const BASE = process.env.REACT_APP_API_URL;

// Save (create when body.id is null, else update). createdBy is derived from the
// JWT principal server-side, so it is not sent here.
const saveLabelTemplate = async (body) => {
  const valid = await token_valid();
  if (!valid) return null;
  const token = getToken();
  return axios
    .post(BASE + "/api/label-template/save", body, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
    })
    .then((r) => r.data)
    .catch((e) => {
      console.log("saveLabelTemplate error", e);
      return null;
    });
};

const getLabelTemplateById = async (id) => {
  const valid = await token_valid();
  if (!valid) return null;
  const token = getToken();
  return axios
    .get(BASE + "/api/label-template/" + id, {
      headers: { Authorization: "Bearer " + token },
    })
    .then((r) => r.data)
    .catch((e) => {
      console.log("getLabelTemplateById error", e);
      return null;
    });
};

const listLabelTemplates = async () => {
  const valid = await token_valid();
  if (!valid) return [];
  const token = getToken();
  return axios
    .get(BASE + "/api/label-template/all", {
      headers: { Authorization: "Bearer " + token },
    })
    .then((r) => r.data)
    .catch((e) => {
      console.log("listLabelTemplates error", e);
      return [];
    });
};

const listLabelTemplatesByBarcode = async (barcode) => {
  const valid = await token_valid();
  if (!valid) return [];
  const token = getToken();
  return axios
    .get(BASE + "/api/label-template/by-barcode/" + encodeURIComponent(barcode), {
      headers: { Authorization: "Bearer " + token },
    })
    .then((r) => r.data)
    .catch((e) => {
      console.log("listLabelTemplatesByBarcode error", e);
      return [];
    });
};

const deleteLabelTemplate = async (id) => {
  const valid = await token_valid();
  if (!valid) return false;
  const token = getToken();
  return axios
    .post(
      BASE + "/api/label-template/delete/" + id,
      {},
      { headers: { Authorization: "Bearer " + token } }
    )
    .then(() => true)
    .catch((e) => {
      console.log("deleteLabelTemplate error", e);
      return false;
    });
};

// Record a run that has just gone to the printer, so the serials it consumed are
// never handed out again.
const recordLabelPrintRun = async (body) => {
  const valid = await token_valid();
  if (!valid) return null;
  const token = getToken();
  return axios
    .post(BASE + "/api/label-print-run/record", body, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
    })
    .then((r) => r.data)
    .catch((e) => {
      console.log("recordLabelPrintRun error", e);
      return null;
    });
};

/** Serial a new run should start at for this product. 1 when nothing printed yet. */
const getNextSerial = async (barcode) => {
  const valid = await token_valid();
  if (!valid) return null;
  const token = getToken();
  return axios
    .get(BASE + "/api/label-print-run/next-serial/" + encodeURIComponent(barcode), {
      headers: { Authorization: "Bearer " + token },
    })
    .then((r) => (r.data && r.data.nextSerial != null ? Number(r.data.nextSerial) : null))
    .catch((e) => {
      console.log("getNextSerial error", e);
      return null;
    });
};

const listPrintRunsByTemplate = async (labelTemplateId) => {
  const valid = await token_valid();
  if (!valid) return [];
  const token = getToken();
  return axios
    .get(BASE + "/api/label-print-run/by-template/" + labelTemplateId, {
      headers: { Authorization: "Bearer " + token },
    })
    .then((r) => r.data)
    .catch((e) => {
      console.log("listPrintRunsByTemplate error", e);
      return [];
    });
};

/** Resolve raw scanned text back to the run that printed it. */
const lookupScannedLabel = async (payload) => {
  const valid = await token_valid();
  if (!valid) return null;
  const token = getToken();
  return axios
    .post(
      BASE + "/api/label-print-run/lookup",
      { payload },
      { headers: { "Content-Type": "application/json", Authorization: "Bearer " + token } }
    )
    .then((r) => r.data)
    .catch((e) => {
      console.log("lookupScannedLabel error", e);
      return null;
    });
};

export {
  lookupScannedLabel,
  recordLabelPrintRun,
  getNextSerial,
  listPrintRunsByTemplate,
  saveLabelTemplate,
  getLabelTemplateById,
  listLabelTemplates,
  listLabelTemplatesByBarcode,
  deleteLabelTemplate,
};
